<script>
export default {
  name: 'TransparentWrapper',
  functional: true,
  render(h, ctx) {
    return ctx.children;
  },
};
</script>
